import React from "react";
import PrivateCalendar from './index'
import { Box } from "@mui/material";
import { Typography } from '@mui/material';

const App: React.FC<{ isPublic: boolean }> = (props) => {
    return <>
        <Box height={100} width={'100%'} sx={
            {
                backgroundImage: `url("https://equimatch.co.nz/wp-content/uploads/2021/11/DSC08115-scaled.jpg")`,
                backgroundRepeat: `no-repeat`,
                height: "376px",
                width: "100%",
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                marginBottom: '20px',
                position: 'relative'
            }
        }>
            <Box width={'100%'} height={'100%'} sx={
                {
                    backgroundColor: 'black',
                    opacity: 0.5,
                    position: 'absolute',  // 使用绝对定位
                    top: 0,
                    left: 0
                }
            } />

            <Box
                width={'100%'}
                height={'100%'}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative'  // 使用相对定位
                }}
            >
                <Typography variant="h2" color={'white'} sx={{ fontSize: "76px", fontWeight: '600', fontFamily: `"Playfair Display SC", Sans-serif` }}>
                    Calendar
                </Typography>
            </Box>
        </Box>
        <PrivateCalendar isPublic={true} />
    </>
}

export default App;